<template>
  <span
    class="pulse-tag"
    :class="[color ? '' : `pulse-tag--${severity}`, { 'pulse-tag--rounded': rounded }]"
    :style="customStyle"
  >
    <i v-if="icon" :class="icon" />
    <slot>{{ value }}</slot>
  </span>
</template>

<script>
export default {
  name: "PulseTag",
  props: {
    value: { type: [String, Number], default: "" },
    severity: { type: String, default: "primary" },
    color: { type: String, default: "" },
    icon: { type: String, default: "" },
    rounded: Boolean,
  },
  computed: {
    customStyle() {
      if (!this.color) return null;
      const hex = this.color.replace("#", "");
      if (hex.length !== 6) return { backgroundColor: this.color, color: "#fff" };
      const [r, g, b] = [0, 2, 4].map((i) => parseInt(hex.substring(i, i + 2), 16));
      return {
        backgroundColor: `rgba(${r}, ${g}, ${b}, 0.14)`,
        color: this.color,
      };
    },
  },
};
</script>
